<template>
  <div>
    <dash-attempt
      v-for="value in values"
      :key="value.index"
      :attemptId="value.attemptId"
      :firstItem="value.firstItem"
      :label="value.label"
      :description="$t(value.description, { amount: value.amount })"
      :thirdLine="value.thirdLine"
      :textBadge="value.textBadge"
      :trailingText="$t('details')"
      :color="value.color"
      @handleClick="() => $emit('item', value.data)"
      :eventProps="historyEvent"
    />
  </div>
</template>

<script>
import DashAttempt from '@cproject/globals/DashAttempt'
import TransactionTimelineManager from './transaction-timeline.manager'

export default {
  name: 'TransactionTimelineItem',
  components: {
    DashAttempt
  },
  props: {
    transactions: {
      type: Array,
      requerid: true
    }
  },
  computed: {
    values () {
      return new TransactionTimelineManager(
        this.transactions
      ).adapterDataTimeline()
    },
    historyEvent () {
      return {
        amplitudeInstance: 'chargesEvents',
        eventFunctionName: 'detailsHistoryItemClicked'
      }
    }
  }
}
</script>

<i18n>
{
    "pt-BR": {
      "value-capture-pending": "Aprovada pelo banco emissor",
      "value-captured": "Valor capturado: {amount}",
      "value-refunded": "Valor estornado: {amount}",
      "value-reproved": "Avaliada como suspeita pelo Antifraude",
      "value-paid": "Valor pago: {amount}",
      "value-refund": "Valor do estorno: {amount}",
      "value-canceled": "Valor cancelado: {amount}",
      "details": "Detalhe"
    },
    "en-US": {
      "value-capture-pending": "Approved by the issuing bank",
      "value-captured": "Captured Value: {amount}",
      "value-refunded": "Refunded value: {amount}",
      "value-reproved": "Assessed as suspicious by Anti-Fraud",
      "value-paid": "Paid value: {amount}",
      "value-refund": "Refund value: {amount}",
      "value-canceled": "Canceled value: {amount}",
      "details": "Detail"
    }
}
</i18n>
